export default __webpack_public_path__ + "static/cercle_vicieux_uw_nl-99c2512c0a2635ded523a078f995fbbb.mp4";